export default "__VITE_ASSET__CXi$HNM7__"